import pLimit from 'p-limit';

/**
 * A mutex that only allows one promise to run at a time.
 *
 * @see https://github.com/sindresorhus/p-limit#readme
 */
export default pLimit(1);
